import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { LINK_LIST } from './types';
import LinkList from './LinkList';

const modals = {
  [LINK_LIST]: LinkList,
};

function Provider({ variant }) {
  const Modal = modals[variant];

  if (!Modal) return null;

  return <Modal />;
}

Provider.propTypes = {
  variant: PropTypes.string.isRequired,
};

const mapStateToProps = ({ modal: { variant } }) => ({
  variant,
});

export default connect(mapStateToProps)(Provider);
